// The Worker is reached at the relative path `/api` (proxied in dev, same-origin
// in prod). Override with VITE_API_BASE for split-origin deployments.
const rawBase = import.meta.env.VITE_API_BASE as string | undefined;
export const API_BASE = (rawBase && rawBase.trim() ? rawBase.trim() : '/api').replace(/\/+$/, '');

const rawShareBase = import.meta.env.VITE_SHARE_BASE as string | undefined;

function defaultShareBase(): string {
  const url = new URL(location.origin);
  if (url.hostname.startsWith('www.')) url.hostname = url.hostname.slice(4);
  return url.origin;
}

export const SHARE_BASE = (rawShareBase && rawShareBase.trim() ? rawShareBase.trim() : defaultShareBase()).replace(
  /\/+$/,
  '',
);

// Fallback only; the authoritative chunk size comes from the initiate response.
export const FALLBACK_CHUNK_SIZE = 32 * 1024 * 1024;

export const RETENTION_OPTIONS = [1, 3, 5, 7] as const;
export const DEFAULT_RETENTION = 3;
export const MAX_FILE_SIZE = 5 * 1024 * 1024 * 1024;
